
import React from 'react';
import { IntegrationApp, Language } from '../../types';
import { TRANSLATIONS } from '../../constants';

interface IntegrationsHeaderProps {
  language: Language;
  selectedApp: IntegrationApp;
  activeTab: 'dashboard' | 'settings' | 'live';
  setActiveTab: (tab: 'dashboard' | 'settings' | 'live') => void;
  onBack: () => void;
}

const IntegrationsHeader: React.FC<IntegrationsHeaderProps> = ({ 
  language, selectedApp, activeTab, setActiveTab, onBack 
}) => {
  const t = TRANSLATIONS[language];
  const isRtl = language === 'ar';

  const IntegrationIcon = ({ name, icon }: { name: string, icon: string }) => {
     return <i className={`fa-brands ${icon.replace('fa-', '')} ${icon}`}></i>;
  };

  return (
       <div className="p-4 lg:p-6 bg-white dark:bg-[#15151a] border-b border-slate-200 dark:border-white/5 flex items-center justify-between shrink-0">
          <div className="flex items-center gap-4">
             <button onClick={onBack} className="w-10 h-10 rounded-xl hover:bg-slate-100 dark:hover:bg-white/5 flex items-center justify-center text-slate-500 transition-colors">
                <i className={`fas fa-arrow-${isRtl ? 'right' : 'left'}`}></i>
             </button>
             <div className="flex items-center gap-3">
                <div className={`w-10 h-10 rounded-xl bg-gradient-to-br ${selectedApp.color} flex items-center justify-center text-white text-lg`}>
                   <IntegrationIcon name={selectedApp.name} icon={selectedApp.icon} />
                </div>
                <div>
                   <h2 className="text-lg font-black text-slate-800 dark:text-white">{selectedApp.name}</h2>
                   <div className="flex items-center gap-2">
                      <span className={`w-2 h-2 rounded-full ${selectedApp.connected ? 'bg-emerald-500' : 'bg-slate-400'}`}></span>
                      <span className="text-[10px] font-bold text-slate-500 dark:text-slate-400 uppercase">{selectedApp.connected ? 'Online' : 'Offline'}</span>
                   </div>
                </div>
             </div>
          </div>
          
          <div className="flex bg-slate-100 dark:bg-black/20 p-1 rounded-xl">
             <button onClick={() => setActiveTab('dashboard')} className={`px-4 py-2 rounded-lg text-xs font-bold transition-all ${activeTab === 'dashboard' ? 'bg-white dark:bg-white/10 text-slate-800 dark:text-white shadow-sm' : 'text-slate-500'}`}>Dashboard</button>
             <button onClick={() => setActiveTab('settings')} className={`px-4 py-2 rounded-lg text-xs font-bold transition-all ${activeTab === 'settings' ? 'bg-white dark:bg-white/10 text-slate-800 dark:text-white shadow-sm' : 'text-slate-500'}`}>Settings</button>
             {selectedApp.connected && (
               <button onClick={() => setActiveTab('live')} className={`px-4 py-2 rounded-lg text-xs font-bold transition-all ${activeTab === 'live' ? 'bg-emerald-500 text-white shadow-sm' : 'text-slate-500'}`}>Live View</button>
             )}
          </div>
       </div>
  );
};

export default IntegrationsHeader;
